import React from 'react';

export default function Spinner() {
  return (
    <div className="relative w-full h-full d-flex items-center justify-center">
      {/* Blur/Dark background */}
      <div className="bg-white/60 backdrop-blur-sm z-10" />

      {/* Bouncing dots loader */}
      <div className="flex items-center justify-center z-20 h-full">
        <div className="flex space-x-2">
          <span className="w-3 h-3 bg-[#3a51bb] rounded-full animate-bounce [animation-delay:-0.3s]" />
          <span className="w-3 h-3 bg-[#3a51bb] rounded-full animate-bounce [animation-delay:-0.15s]" />
          <span className="w-3 h-3 bg-[#3a51bb] rounded-full animate-bounce" />
        </div>
      </div>
    </div>
  );
}
